import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import useUser from "@hooks/use-user";
import { Loader } from "@components/loader";
import { ApolloProvider } from "@apollo/client";
import { PermissionsProvider } from "@contexts/permissions.context";
import { useGQLClient } from "@utils/graphql.util";
import { TimezoneProvider } from "@contexts/timezone.context";

const PrivateLayout: FC = () => {
  const { user, loading } = useUser();
  const client = useGQLClient();
  const { pathname } = useLocation();

  // Show a loading screen while checking authentication
  if (loading) {
    return <Loader />;
  }

  if (!user) {
    localStorage.setItem("ul_redirect_path", pathname);
    return <Navigate to="/auth/signin" replace />;
  }

  // Redirect to login if not authenticated
  return (
    <ApolloProvider client={client}>
      <TimezoneProvider>
        <PermissionsProvider>
          <Outlet context={user} />
        </PermissionsProvider>
      </TimezoneProvider>
    </ApolloProvider>
  );
};

export default PrivateLayout;
